import { Select } from '@radix-ui/themes';
import { useAuth } from '../../contexts/AuthContext';
import { useGetDiscordBotsQuery } from '../../graphql/queries/GetDiscordBots.generated';

interface DiscordBotSelectProps {
  botId?: string;
  onValueChange: (value: string) => void;
  disabled?: boolean;
}

const DiscordBotSelect = ({
  botId,
  onValueChange,
  disabled,
}: DiscordBotSelectProps) => {
  const { user } = useAuth();
  const { data, loading, error } = useGetDiscordBotsQuery({
    variables: { ownerUserId: user?.id },
  });

  if (loading) {
    return (
      <Select.Root disabled={true}>
        <Select.Trigger
          placeholder="Loading bots..."
          style={{ width: '100%' }}
        />
      </Select.Root>
    );
  }

  if (error || !data) {
    return (
      <Select.Root disabled={true}>
        <Select.Trigger
          placeholder="Error loading Discord bots"
          style={{ width: '100%' }}
        />
      </Select.Root>
    );
  }

  const bots = data.discordBots.filter((bot) => bot.isActive);

  return (
    <Select.Root
      value={botId}
      onValueChange={onValueChange}
      disabled={disabled}
    >
      <Select.Trigger
        placeholder={
          bots.length === 0
            ? 'No active Discord bots found'
            : 'Select a Discord bot'
        }
        style={{ width: '100%' }}
      />
      <Select.Content>
        {bots.map((bot) => (
          <Select.Item key={bot.id} value={bot.id}>
            {bot.botUsername || 'Unnamed Bot'} ({bot.guildName || 'No Guild'})
          </Select.Item>
        ))}
      </Select.Content>
    </Select.Root>
  );
};

export default DiscordBotSelect;
